import { render } from "./TaskEditModal.vue?vue&type=template&id=a3631492&scoped=true"
import script from "./TaskEditModal.vue?vue&type=script&lang=js"
export * from "./TaskEditModal.vue?vue&type=script&lang=js"

import "./TaskEditModal.vue?vue&type=style&index=0&id=a3631492&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3631492"]])

export default __exports__